<template>
    <div class="modal_bg" @click="fnEvent(false)"></div>
    <div class="modal_layer">
        <div class="modal_title">
            {{ props.isEdit ? "수정" : "등록" }}
            <div class="close_btn" @click="fnEvent(false)">
                <img src="@/assets/common/close.png" alt="" />
            </div>
        </div>
        <form action="">
            <div class="modal_content">
                <div class="user_modal">
                    <div>
                        <p>플랫폼</p>
                        <select v-model="info.platform">
                            <option :value="0">선택해주세요.</option>
                            <option v-for="option in options.platform" :value="option.idx">{{ option.name }}</option>
                        </select>
                    </div>
                    <div>
                        <p>구분</p>
                        <select v-model="info.gubun">
                            <option :value="0">선택해주세요.</option>
                            <option v-for="option in options.gubun" :value="option.idx">{{ option.name }}</option>
                        </select>
                    </div>
                    <div>
                        <p>업종</p>
                        <select v-model="info.industry">
                            <option :value="0">선택해주세요.</option>
                            <option v-for="option in options.industry" :value="option.idx">{{ option.name }}</option>
                        </select>
                    </div>
                    <div>
                        <p>제목</p>
                        <input type="text" placeholder="내용을 입력해주세요." v-model="info.title" />
                    </div>

                    <div>
                        <p>링크</p>
                        <input type="text" placeholder="링크를 입력해주세요." v-model="info.link" />
                    </div>
                    <div>
                        <p>설명</p>
                        <textarea placeholder="설명" v-model="info.description"></textarea>
                    </div>
                    <div class="checkbox_wrap">
                        <p class="checkbox_title">활성화 여부</p>
                        <label class="chk">
                            <input type="checkbox" v-model="info.isActive" :true-value="1" :false-value="0" />
                            <span></span>
                        </label>
                    </div>
                    <div class="checkbox_wrap">
                        <p class="checkbox_title">그루밍 성착취 의심</p>
                        <label class="chk">
                            <input type="checkbox" v-model="info.isDoubt" :true-value="1" :false-value="0" />
                            <span></span>
                        </label>
                    </div>
                </div>
                <div class="modal_btns">
                    <div class="modal_btn" @click="fnEvent(true)">{{ props.isEdit ? "수정" : "등록" }}</div>
                    <div class="modal_btn" @click="fnEvent(false)">취소</div>
                </div>
            </div>
        </form>
    </div>
</template>
<script lang="ts">
    import { onMounted, onUnmounted, onlyNumInput, reactive, watch } from "@/BaseComponent";

    export default {
        props: ["info", "isEdit"],
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const info = reactive({
                idx: 0 as number,
                title: "" as string | "",
                platform: 0 as number,
                gubun: 0 as number,
                industry: 0 as number,
                isActive: 0 as number,
                isDoubt: 0 as number,
                link: "" as string,
                description: "" as string,
            });

            const options = {
                platform: [
                    { idx: 1, name: "Telegram" },
                    { idx: 2, name: "Discord" },
                    { idx: 4, name: "KakaoTalk" },
                    { idx: 3, name: "기타" },
                ],
                gubun: [
                    { idx: 1, name: "성매매 업소 광고 대행" },
                    { idx: 2, name: "성매매 업소 예약관리 및 광고" },
                    { idx: 3, name: "성매매 업소 광고 알림" },
                    { idx: 4, name: "성매매알선포털사이트 주소 알림" },
                    { idx: 5, name: "성매수 후기 공유" },
                    { idx: 6, name: "성매매 관련 커뮤니티" },
                    { idx: 7, name: "성적 대상화 콘텐츠 공유" },
                    { idx: 8, name: "성적 대화 공유" },
                    { idx: 9, name: "기타 커뮤니티" },
                ],
                industry: [
                    { idx: 1, name: "마사지" },
                    { idx: 2, name: "오피" },
                    { idx: 3, name: "유흥주점" },
                    { idx: 4, name: "키스방" },
                    { idx: 5, name: "출장마사지 알선 사이트" },
                    { idx: 6, name: "휴게텔" },
                    { idx: 7, name: "해외 성매매 알선" },
                    { idx: 8, name: "성매매알선포털사이트" },
                    { idx: 9, name: "성매수자 커뮤니티" },
                    { idx: 10, name: "기타" },
                    { idx: 11, name: "해당없음" },
                ],
            };

            onMounted(() => {
                if (props.info) {
                    info.idx = props.info.idx ? props.info.idx : "";
                    info.title = props.info.title ? props.info.title : "";
                    info.platform = props.info.platform ? props.info.platform : 0;
                    info.gubun = props.info.gubun ? props.info.gubun : 0;
                    info.industry = props.info.industry ? props.info.industry : 0;
                    info.link = props.info.link ? props.info.link : "";
                    info.description = props.info.description ? props.info.description : "";
                    info.isActive = props.info.isActive ? props.info.isActive : "";
                    info.isDoubt = props.info.isDoubt ? props.info.isDoubt : "";
                }
                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "auto";
            });

            watch(
                () => props.info,
                () => {
                    if (props.info) {
                        info.idx = props.info.idx ? props.info.idx : "";
                        info.title = props.info.title ? props.info.title : "";
                        info.platform = props.info.platform ? props.info.platform : 0;
                        info.gubun = props.info.gubun ? props.info.gubun : 0;
                        info.industry = props.info.industry ? props.info.industry : 0;
                        info.link = props.info.link ? props.info.link : "";
                        info.description = props.info.description ? props.info.description : "";
                        info.isActive = props.info.isActive ? props.info.isActive : "";
                        info.isDoubt = props.info.isDoubt ? props.info.isDoubt : "";
                    }
                },
            );

            const fnEvent = (result: boolean) => {
                if (result) {
                    if (!info.platform) return alert("플랫폼을 선택해주세요");
                    if (!info.title) return alert("제목을 입력해주세요");
                    if (!info.link) return alert("링크를 입력해주세요");
                }
                const data = {
                    result,
                    info,
                };
                emit("close", data);
            };

            return { props, info, options, fnEvent, onlyNumInput };
        },
    };
</script>

<style scoped>
    .modal_content > .user_modal > div > input {
        height: auto;
    }
    .modal_btns {
        display: flex;
        flex-direction: row;
        gap: 20px;
        align-items: center;
        justify-content: center;
    }
    .modal_btns .modal_btn {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .checkbox_wrap {
        justify-content: start;
    }

    .checkbox_wrap .checkbox_title {
        min-width: 138px;
    }
</style>
